import script from "./qtSplitLayout.vue?vue&type=script&setup=true&name=qtSplit&lang=js"
export * from "./qtSplitLayout.vue?vue&type=script&setup=true&name=qtSplit&lang=js"

import "./qtSplitLayout.vue?vue&type=style&index=0&id=6a1d7fe0&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a1d7fe0"]])

export default __exports__